import axios from '@/js/lib/axios';
import { updateToken } from './update_token';

export interface EntryShopData {
  email: string;
  shopName: string;
  name: string;
  address: string;
  phoneNumber: string;
  companyName: string;
  categories: string[];
  isVintage: boolean;
  siteUrl: string;
  instagramUrl: string;
  freeArea: string;
  isGranted: boolean;
}

export const entryShop = async ({ email, shopName, name, address, phoneNumber, companyName, categories, isVintage, siteUrl, instagramUrl, freeArea, isGranted }: EntryShopData): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  if (email) {
    params.append('email', email);
  }
  if (shopName) {
    params.append('shop_name', shopName);
  }
  params.append('name', name);
  params.append('address', address);
  params.append('phone_number', phoneNumber);
  params.append('company_name', companyName ?? '');
  params.append('categories', categories.join(','));
  params.append('is_vintage', String(Number(isVintage)));
  params.append('site_url', siteUrl ?? '');
  params.append('instagram_url', instagramUrl ?? '');
  params.append('free_area', freeArea ?? '');
  params.append('is_granted', String(Number(isGranted)));
  params.append('token', token);
  const res = await axios.post('/api/shop-entry', params);
  return res.data;
};

export const setupShop = async ({ hash, shopName, password }): Promise<''> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('hash', hash);
  params.append('shop_name', shopName);
  params.append('password', password);
  params.append('token', token);
  const res = await axios.post('/api/shop-entry/setup', params);
  return res.data;
};

export const validateShopEmail = async ({ email }): Promise<''> => {
  const res = await axios.get('/api/shop-entry/validate-email', { params: { email } });
  return res.data;
};
